import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PrestadorControleAdministrativoService } from '@/core/api/sicom-api/registro/prestador/controle-administrativo/prestador-controle-administrativo.service';
import { PrestadorEstatisticaAgrupadaResponse, PrestadorEstatisticaCadastroAnaliticoResponse } from '@/core/api/sicom-api/registro/prestador/controle-administrativo/prestador-estatistica-agrupada.model';
import { MedicoCadastroGeralResponse } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-cadastro-geral.model';
import { Page } from '@/shared/models/page.model';
import { CustomService } from '@/shared/services/custom.service';

@Injectable({ providedIn: 'root' })
export class PrestadorControleAdministrativoFeatureService extends CustomService {
    constructor(private core: PrestadorControleAdministrativoService) {
        super();
    }

    consultarPrestadoresPorSituacao(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorSituacao(uf, limite).pipe(catchError(this.handleError));
    }

    consultarAtivosPorRegistroCadastro(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarAtivosPorRegistroCadastro(uf).pipe(catchError(this.handleError));
    }

    consultarNovasInscricoesPorMes(uf?: string, ano?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarNovasInscricoesPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorMunicipio(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorMunicipio(uf, limite).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorTipoEstabelecimento(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorTipoEstabelecimento(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorCategoria(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorCategoria(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorNatureza(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorNatureza(uf).pipe(catchError(this.handleError));
    }

    consultarEnderecosCorrespondenciaAusentes(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEnderecosCorrespondenciaAusentes(uf).pipe(catchError(this.handleError));
    }

    consultarCertificadosPorSituacao(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCertificadosPorSituacao(uf).pipe(catchError(this.handleError));
    }

    consultarCertificadosPorFaixaVencimento(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCertificadosPorFaixaVencimento(uf).pipe(catchError(this.handleError));
    }

    consultarRenovacoesCertificadoPorMes(uf?: string, ano?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarRenovacoesCertificadoPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarTempoMedioRenovacaoCertificado(uf?: string, ano?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTempoMedioRenovacaoCertificado(uf, ano).pipe(catchError(this.handleError));
    }

    consultarPrestadoresSemDiretorTecnico(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresSemDiretorTecnico(uf).pipe(catchError(this.handleError));
    }

    consultarDiretoresTecnicosPorVinculos(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDiretoresTecnicosPorVinculos(uf).pipe(catchError(this.handleError));
    }

    consultarDiretoriaDuplicada(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDiretoriaDuplicada(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorTamanhoCorpoClinico(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorTamanhoCorpoClinico(uf).pipe(catchError(this.handleError));
    }

    consultarCorpoClinicoPorNaturezaVinculo(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCorpoClinicoPorNaturezaVinculo(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorComissaoEticaVigente(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorComissaoEticaVigente(uf).pipe(catchError(this.handleError));
    }

    consultarComissaoEticaPorVencimento(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarComissaoEticaPorVencimento(uf).pipe(catchError(this.handleError));
    }

    consultarComissaoEticaObrigatoriaAusente(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarComissaoEticaObrigatoriaAusente(uf).pipe(catchError(this.handleError));
    }

    consultarComissoesObrigatoriasPorTipo(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarComissoesObrigatoriasPorTipo(uf).pipe(catchError(this.handleError));
    }

    consultarCnaesPrincipais(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCnaesPrincipais(uf, limite).pipe(catchError(this.handleError));
    }

    consultarPrestadoresSemCnaePrincipal(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresSemCnaePrincipal(uf).pipe(catchError(this.handleError));
    }

    consultarCnaesSecundariosPorPrestador(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCnaesSecundariosPorPrestador(uf).pipe(catchError(this.handleError));
    }

    consultarServicosMaisDeclarados(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarServicosMaisDeclarados(uf, limite).pipe(catchError(this.handleError));
    }

    consultarAtividadesDesenvolvidas(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarAtividadesDesenvolvidas(uf, limite).pipe(catchError(this.handleError));
    }

    consultarRecursosHumanosPorTipo(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarRecursosHumanosPorTipo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarRecursosMateriaisPorTipo(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarRecursosMateriaisPorTipo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarEspecialidadesMaisRegistradas(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEspecialidadesMaisRegistradas(uf, limite).pipe(catchError(this.handleError));
    }

    consultarPrestadoresSemEspecialidadeObrigatoria(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresSemEspecialidadeObrigatoria(uf).pipe(catchError(this.handleError));
    }

    consultarPendenciasManuaisPorTipo(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPendenciasManuaisPorTipo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarPendenciasOperacionaisPorTipo(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPendenciasOperacionaisPorTipo(uf).pipe(catchError(this.handleError));
    }

    consultarDuplicidadesCnpj(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDuplicidadesCnpj(uf).pipe(catchError(this.handleError));
    }

    consultarRazaoMedicosPrestadores(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarRazaoMedicosPrestadores(uf).pipe(catchError(this.handleError));
    }

    consultarMultivinculoCorpoClinico(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarMultivinculoCorpoClinico(uf).pipe(catchError(this.handleError));
    }

    consultarDiretoresTecnicosPorFaixaEtaria(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDiretoresTecnicosPorFaixaEtaria(uf).pipe(catchError(this.handleError));
    }

    consultarCicloVidaPrestador(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCicloVidaPrestador(uf).pipe(catchError(this.handleError));
    }

    consultarCapacidadeInstaladaPorUf(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCapacidadeInstaladaPorUf(uf, limite).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorFaixaCapitalSocial(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorFaixaCapitalSocial(uf).pipe(catchError(this.handleError));
    }

    consultarEnderecosCorrespondenciaDesatualizados(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEnderecosCorrespondenciaDesatualizados(uf).pipe(catchError(this.handleError));
    }

    consultarVinculadosEmDebito(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarVinculadosEmDebito(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorDelegacia(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorDelegacia(uf, limite).pipe(catchError(this.handleError));
    }

    consultarEleitoradoPorCorpoClinico(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEleitoradoPorCorpoClinico(uf, limite).pipe(catchError(this.handleError));
    }

    consultarCadastroGeralPrestador(): Observable<MedicoCadastroGeralResponse[]> {
        return this.core.consultarCadastroGeralPrestador().pipe(catchError(this.handleError));
    }

    consultarTotalPrestadoresAtivosNaData(uf: string | undefined, data: string): Observable<number> {
        return this.core.consultarTotalPrestadoresAtivosNaData(uf, data).pipe(catchError(this.handleError));
    }

    consultarPrestadoresAtivosNaData(uf: string | undefined, data: string, page?: number, size?: number): Observable<Page<PrestadorEstatisticaCadastroAnaliticoResponse>> {
        return this.core.consultarPrestadoresAtivosNaData(uf, data, page, size).pipe(catchError(this.handleError));
    }

    consultarSociosPorFaixa(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSociosPorFaixa(uf).pipe(catchError(this.handleError));
    }

    consultarSociosPorCargo(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSociosPorCargo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarFiliaisPorLocalizacaoMatriz(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarFiliaisPorLocalizacaoMatriz(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresSemCnes(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresSemCnes(uf).pipe(catchError(this.handleError));
    }

    consultarMovimentacaoSituacaoPjPorMes(uf?: string, ano?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarMovimentacaoSituacaoPjPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarPreCadastrosPrestadorPorUf(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPreCadastrosPrestadorPorUf(uf, limite).pipe(catchError(this.handleError));
    }

    consultarChefiasPorServico(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarChefiasPorServico(uf, limite).pipe(catchError(this.handleError));
    }

    consultarServicosSemChefia(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarServicosSemChefia(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorDocumentoConstituicao(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorDocumentoConstituicao(uf, limite).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorEnsino(uf?: string): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorEnsino(uf).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorGestao(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorGestao(uf, limite).pipe(catchError(this.handleError));
    }

    consultarPrestadoresPorAbrangencia(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPrestadoresPorAbrangencia(uf, limite).pipe(catchError(this.handleError));
    }

    consultarCorpoClinicoEntradasPorMes(uf?: string, ano?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCorpoClinicoEntradasPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarCorpoClinicoSaidasPorMes(uf?: string, ano?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCorpoClinicoSaidasPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarAnotacoesPrestadorPorTipo(uf?: string, limite?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarAnotacoesPrestadorPorTipo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarAnotacoesPrestadorPorMes(uf?: string, ano?: number): Observable<PrestadorEstatisticaAgrupadaResponse[]> {
        return this.core.consultarAnotacoesPrestadorPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarPrestadoresEstatisticaCadastro(estatisticaId: string, uf?: string | null, ano?: number, page?: number, size?: number, codigo?: string | null): Observable<Page<PrestadorEstatisticaCadastroAnaliticoResponse>> {
        return this.core.consultarPrestadoresEstatisticaCadastro(estatisticaId, uf, ano, page, size, codigo).pipe(catchError(this.handleError));
    }
}
